import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { globalFormManagementServices } from "../../../../../APIServices/globalFormManagementServices";

const UpdateFormFieldGroup = ({
  fieldGroup,
  getGlobalFormFieldGroup,
  Show,
  Hide,
  Title,
  setCategoryId,
}) => {
  const [categoryLabel, setCategoryLabel] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [categoryCodeLabel, setCategoryCodeLabel] = useState("");
  const [categoryCodeName, setCategoryCodeName] = useState("");
  const [categoryValueLabel, setCategoryValueLabel] = useState("");
  const [categoryValueName, setCategoryValueName] = useState("");
  const [categoryUnitLabel, setCategoryUnitLabel] = useState("");
  const [categoryUnitName, setCategoryUnitName] = useState("");
  const [categoryRemarkLabel, setCategoryRemarkLabel] = useState("");
  const [categoryRemarkName, setCategoryRemarkName] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const updateGlobalFormFieldGroup = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Form Field Group!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = fieldGroup?._id;
        userData.categoryLabel = categoryLabel;
        userData.categoryName = categoryName;
        userData.categoryCodeLabel = categoryCodeLabel;
        userData.categoryCodeName = categoryCodeName;
        userData.categoryValueLabel = categoryValueLabel;
        userData.categoryValueName = categoryValueName;
        userData.categoryUnitLabel = categoryUnitLabel;
        userData.categoryUnitName = categoryUnitName;
        userData.categoryRemarkLabel = categoryRemarkLabel;
        userData.categoryRemarkName = categoryRemarkName;
        let data =
          await globalFormManagementServices.updateGlobalFormFieldGroup(
            userData
          );
        if (data?.statusCode === 200) {
          getGlobalFormFieldGroup();
          Hide();
          setCategoryId("");
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setCategoryLabel(fieldGroup?.categoryLabel);
    setCategoryName(fieldGroup?.categoryName);
    setCategoryCodeLabel(categoryCodeLabel);
    setCategoryCodeName(categoryCodeName);
    setCategoryValueLabel(fieldGroup?.categoryValueLabel);
    setCategoryValueName(fieldGroup?.categoryValueName);
    setCategoryUnitLabel(fieldGroup?.categoryUnitLabel);
    setCategoryUnitName(fieldGroup?.categoryUnitName);
    setCategoryRemarkLabel(fieldGroup?.categoryRemarkLabel);
    setCategoryRemarkName(fieldGroup?.categoryRemarkName);
  }, [fieldGroup]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCategoryLabel(e.target.value)}
              value={categoryLabel}
              className="br3"
              placeholder="Category Label"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                const input = e.target.value
                  .toUpperCase()
                  .replace(/[^A-Z0-9]/g, "");
                setCategoryName(input);
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              value={categoryName}
              className="br3"
              placeholder="Category Name"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Code Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCategoryCodeLabel(e.target.value)}
              value={categoryCodeLabel}
              className="br3"
              placeholder="Category Code Label"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Code Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                const input = e.target.value
                  .toUpperCase()
                  .replace(/[^A-Z0-9]/g, "");
                setCategoryCodeName(input);
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              value={categoryCodeName}
              className="br3"
              placeholder="Category Code Name"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Value Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCategoryValueLabel(e.target.value)}
              value={categoryValueLabel}
              className="br3"
              placeholder="Category Value Label"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Value Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                const input = e.target.value
                  .toUpperCase()
                  .replace(/[^A-Z0-9]/g, "");
                setCategoryValueName(input);
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              value={categoryValueName}
              className="br3"
              placeholder="Category Value Name"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Unit Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCategoryUnitLabel(e.target.value)}
              value={categoryUnitLabel}
              className="br3"
              placeholder="Category Unit Label"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Unit Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                const input = e.target.value
                  .toUpperCase()
                  .replace(/[^A-Z0-9]/g, "");
                setCategoryUnitName(input);
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              value={categoryUnitName}
              className="br3"
              placeholder="Category Unit Name"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Remark Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCategoryRemarkLabel(e.target.value)}
              value={categoryRemarkLabel}
              className="br3"
              placeholder="Category Remark Label"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Category Remark Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                const input = e.target.value
                  .toUpperCase()
                  .replace(/[^A-Z0-9]/g, "");
                setCategoryRemarkName(input);
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              value={categoryRemarkName}
              className="br3"
              placeholder="Category Remark Name"
              type="text"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
          <button
            disabled={
              !categoryCodeLabel ||
              !categoryCodeName ||
              !categoryLabel ||
              !categoryName ||
              !categoryValueLabel ||
              !categoryValueName ||
              !categoryUnitLabel ||
              !categoryUnitName ||
              !categoryRemarkLabel ||
              !categoryRemarkName ||
              buttonLoader
            }
            className={`updateProfile`}
            onClick={(e) => updateGlobalFormFieldGroup(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Updating...
              </div>
            ) : (
              "Update form filed group"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateFormFieldGroup;
